export default "__VITE_ASSET__BqAbYU$a__"